import React from 'react';
import AuthenticatedFileButton from '../../components/AuthenticatedFileButton';
import relatorioService from '../../services/relatorioPrestacaoContasService';
import { secondaryButtonClass } from './shared';

type Props = {
  pcId: string;
  anexo: '2' | '3' | '4' | '5' | '6' | '7' | '8';
  nomeArquivo: string;
  comXlsx?: boolean;
};

const DownloadButtons: React.FC<Props> = ({ pcId, anexo, nomeArquivo, comXlsx = true }) => (
  <div className="flex flex-wrap gap-2">
    <AuthenticatedFileButton
      url={relatorioService.downloadUrl(pcId, anexo, 'pdf')}
      fileName={`${nomeArquivo}.pdf`}
      action="download"
      className={`rounded-xl px-3 py-2 text-sm font-semibold transition ${secondaryButtonClass}`}
    >
      Imprimir
    </AuthenticatedFileButton>
    {comXlsx && (
      <AuthenticatedFileButton
        url={relatorioService.downloadUrl(pcId, anexo, 'xlsx')}
        fileName={`${nomeArquivo}.xlsx`}
        action="download"
        className={`rounded-xl px-3 py-2 text-sm font-semibold transition ${secondaryButtonClass}`}
      >
        Baixar XLSX
      </AuthenticatedFileButton>
    )}
  </div>
);

export default DownloadButtons;
